const portraits = {
    id: "portraits",
    title: "Portraits",
    coverImage: "portraitImages/portrait.jpg",
    description: "Intimate human stories captured across cultures.",
    order: 2,
    orientation: "portrait",
    images: [
        {
            src: "portraitImages/IMG_0352.jpg",
            title: "Burning Incense Candles",
            description: "Beauty of devotion in Beijing"
        },
        {
            src: "portraitImages/IMG_0420.jpg",
            title: "Food",
            description: "Culinary in Qianmen, Beijing"
        },
        {
            src: "portraitImages/IMG_0523.jpg",
            title: "Traditional Hanfu",
            description: "Tradition never dies! even in Beijing"
        },
        {
            src: "portraitImages/IMG_0955.jpg",
            title: "Light Gaze",
            description: "Beautiful lights in Xi'An"
        }
        ,
        {
            src: "portraitImages/IMG_6987.jpg",
            title: "She has got style!",
            description: "Female Black Buck in India"
        }
        ,
        {
            src: "portraitImages/IMG_7950.jpg",
            title: "A Bull in Musth",
            description: "Giants of Lanka"
        }
        ,
        {
            src: "portraitImages/IMG_8704.jpg",
            title: "Desert Smoke",
            description: "Two bedouins having a puff in Wadi RUm"
        }
        ,
        {
            src: "portraitImages/IMG_8711.jpg",
            title: "Desert Gaze",
            description: "Bedouins in Wadi Rum."
        }
        ,
        {
            src: "portraitImages/IMG_9147.jpg",
            title: "Golden Light",
            description: "Petra"
        }
        ,
        {
            src: "portraitImages/IMG_9689.jpg",
            title: "Can you smell it?",
            description: "Incense in the streets of Mysore"
        }
        ,
        {
            src: "portraitImages/IMG_9740.jpg",
            title: "FLowers",
            description: "Mysore"
        }
        ,
        {
            src: "portraitImages/IMG_9754.jpg",
            title: "Life is good!",
            description: "Mysore, India"
        }
    ]
};

export default portraits;